import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// To do: find a more cleaner way to adopt boca-btn style without so many !important

const StyledWrap = styled.a`
height: 60px !important;
line-height: 60px !important;
width: 200px !important;
padding: 0 !important;
margin-right: 15px !important;

@media screen and (max-width: 480px) {
  font-size: 1em !important;
  width: 230px !important;
  height: 50px !important;
  line-height: 50px !important;
  margin-right: 0 !important;
  margin-bottom: 10px !important;
}
`;

const LightBtn = ({
  children,
  onClick,
  url,
}) => (
  <StyledWrap
    className="btn boca-btn"
    href={url}
    onClick={onClick}
  >
    {children}
  </StyledWrap>
);

LightBtn.propTypes = {
  children: PropTypes.any,
  onClick: PropTypes.func,
  url: PropTypes.string,
};
LightBtn.defaultProps = {
  children: undefined,
  onClick: () => {},
  url: undefined,
};

export default LightBtn;



// WEBPACK FOOTER //
// ./src/components/landing/HeroBanner/LightBtn.js